import { filterPlannerRowsForEpochMonth } from './PlannerVersionScope'

export const locationClassHasWeeklyPlanSettings = ({ latestMonthlyPlans, selectedLocationClassId, epochMonth = null }) => {
  if (!selectedLocationClassId) return false
  return filterPlannerRowsForEpochMonth(latestMonthlyPlans, {
    locationClassId: selectedLocationClassId,
    epochMonth,
  }).some((row) => {
    const psid = String(row?.weekly_plan_settings_id || '').trim()
    return !!psid
  })
}

export const shouldFallbackWeeklyViewToMonthly = ({
  viewMode,
  selectedLocationClassId,
  latestMonthlyPlansLoaded,
  latestMonthlyPlans,
  epochMonth,
}) => {
  if (viewMode !== 'weekly') return false
  if (!selectedLocationClassId) return false
  if (!latestMonthlyPlansLoaded) return false
  if (!Array.isArray(latestMonthlyPlans) || latestMonthlyPlans.length === 0) return false
  return !locationClassHasWeeklyPlanSettings({ latestMonthlyPlans, selectedLocationClassId, epochMonth })
}

